/*
 * Z4 mega menu hover-intent.
 * On desktop (>=990px, hover-capable pointers) the full-width visual mega menu
 * opens when the pointer enters a top-level category and closes shortly after it
 * leaves. Click on a category with a real mouse is neutralised so it doesn't fight
 * the hover state; keyboard activation (Enter/Space -> click with detail 0) and
 * touch devices keep Dawn's native click-to-toggle behaviour for accessibility.
 */
(function () {
  var desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 140;

  function init() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    menus.forEach(function (menu) {
      var details = menu.querySelector('details.mega-menu');
      if (!details) return;
      var summary = details.querySelector('summary');
      var closeTimer = null;

      function open() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        // Close sibling mega menus so only one panel is open at a time.
        menus.forEach(function (other) {
          if (other === menu) return;
          var d = other.querySelector('details.mega-menu');
          if (d && d.hasAttribute('open')) {
            d.removeAttribute('open');
            var s = d.querySelector('summary');
            if (s) s.setAttribute('aria-expanded', 'false');
          }
        });
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      }

      function close() {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      }

      menu.addEventListener('mouseenter', function () {
        if (desktopHover.matches) open();
      });

      menu.addEventListener('mouseleave', function () {
        if (!desktopHover.matches) return;
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(close, CLOSE_DELAY);
      });

      if (summary) {
        summary.addEventListener('click', function (event) {
          if (!desktopHover.matches) return; // touch / no-hover: native toggle
          if (event.detail === 0) return; // keyboard activation: native toggle
          event.preventDefault(); // real mouse click: hover already controls open state
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
